module.exports = __webpack_public_path__ + "img/assault_cruiser.5ef41082.jpg";